'use client'

import { useEffect, useState } from 'react'

export function ReadingProgress() {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    const updateProgress = () => {
      const scrollTop = window.scrollY
      const docHeight =
        document.documentElement.scrollHeight - window.innerHeight
      setProgress(docHeight > 0 ? (scrollTop / docHeight) * 100 : 0)
    }

    updateProgress()
    window.addEventListener('scroll', updateProgress, { passive: true })
    return () => window.removeEventListener('scroll', updateProgress)
  }, [])

  const width = { width: `${progress}%` }

  return (
    <div className="pointer-events-none fixed inset-x-0 top-0 z-50">
      {/* Halo: a taller blurred copy of the bar, centred on it, so the glow
          radiates all around — above, below and wrapping the leading tip.
          Shares .rp-flow with the hairline so the two stay colour-synced. */}
      <div
        aria-hidden
        className="rp-flow absolute -top-1 left-0 h-3 rounded-r-full opacity-70 blur-[6px] transition-[width] duration-150 ease-out"
        style={width}
      />

      {/* The line — 3px, the minimum at which a corner radius actually reads
          as rounded. Only the leading end is rounded; the left end sits flush
          against the screen edge. */}
      <div
        className="rp-flow relative h-[3px] rounded-r-full transition-[width] duration-150 ease-out"
        style={width}
      />

      <style>{`
        /* Brand mint (--primary-active) through teals with one restrained
           blue stop; ends match so the gradient tiles seamlessly while it
           drifts. */
        .rp-flow {
          background-image: linear-gradient(
            90deg,
            hsl(var(--primary-active)),
            #2dd4bf,
            #38bdf8,
            #14b8a6,
            hsl(var(--primary-active))
          );
          background-size: 200% 100%;
          animation: rp-flow-drift 7s linear infinite;
        }
        @keyframes rp-flow-drift {
          from { background-position-x: 0%; }
          to { background-position-x: 200%; }
        }
        @media (prefers-reduced-motion: reduce) {
          .rp-flow { animation: none; }
        }
      `}</style>
    </div>
  )
}
